<template>
    <div class="container">
        <div class="main-block">
            <div class="store-block" v-if="isLogin">
                <h4 class="mb-0">最近訂位</h4>
                <div class="list-style book-list" v-for="(item , index) in bookList" :key="index">
                    <div class="big mr-3">
                        {{item.bookingTime}}
                    </div>
                    <div class="flex-grow-1">
                        <span>{{item.bookingDate}} {{getWeekName(item.bookingDate)}}</span>
                        <span>{{item.adult}}大 {{item.children}}小</span>
                    </div>
                    <div>
                        <el-button round @click="editBooking(item)">編輯/取消</el-button>
                    </div>
                </div>
                <div class="no-data2" v-if="bookList.length<= 0">
                    <i class="el-icon-lollipop"/>
                    目前沒有訂位
                </div>

                <!--即將到期點數-->
                <BonusPointExpiring class="mt-5" :expiringBonus="rewardPointList"/>

                <h4 class="mt-5 mb-0" v-if="historyList.length > 0">消費紀錄
                    <div class="more"  @click="showHistory">更多 <i class="el-icon-arrow-right"/></div>
                </h4>
                <div class="list-style" v-for="(item , index) in historyList" :key="index+20" @click="showHistoryContent(item.orderSn)">
                    <div class="flex-grow-1">
                        {{item.createdAt}}
                    </div>
                    <div>
                        <span class="big mr-1">{{item.invoicePrice}}</span>元 <i class="el-icon-arrow-right"/>
                    </div>
                </div>
            </div>

        </div>

        <PullDownClose v-if="isShowPullDownHistoryContent" @close="closePullDownHistoryContent">
            <HistoryContent isWeb class="content" :orderSnWeb="pullDownHistoryOrderSn" @close="closePullDownHistoryContent"/>
        </PullDownClose>

        <PullDownClose v-if="isShowPullDownHistory" @close="closePullDownHistory" class="history-content">
            <History isWeb class="content"/>
        </PullDownClose>

        <!--判斷有無登入-->
        <LoginWeb/>

    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutationTypes';
    import PullDownClose from "@/components/PullDownClose";
    import BonusPointExpiring from "@/views/gift/components/BonusPointExpiring"
    import HistoryContent from "@/views/more/history/HistoryContent";
    import History from "@/views/more/history/Index";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
    import LoginWeb from "./components/LoginWeb";
    import {updateFilterStoreId} from "@/store/mutationTypes";

    const weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];

    export default {
        name: "WebStoreMember",
        components: {
            PullDownClose,
            BonusPointExpiring,
            HistoryContent,
            History,
            LoginWeb,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),

                // isLogin: false,
                storeCode: this.$route.params.storeCode, //從router寫入的
                confirmBookingUrl: '',      //編輯訂位用
                bookList: [],
                historyList: [],
                rewardPointOffset: 0,
                rewardPointList: [],
                userData: {
                    name: '',
                },
                pullDownHistoryOrderSn: '',
                isShowPullDownHistoryContent: false,
                isShowPullDownHistory: false,
                filterStoreId: null, //篩選出某一家店的資料
                removeSubscribe: null,
                isCordova: this.$public.isCordova(),
            }
        },
        created() {

        },
        mounted() {
            if (this.isLogin) {
                this.userData = getCryptoUserInfo();
            }
            //取得要單獨過濾的店家ID，line@ web版頁面用
            this.resetByLineWeb()

            this.removeSubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type === updateFilterStoreId) {
                    this.resetByLineWeb();
                }
            });
        },
        beforeDestroy() {
            if (this.removeSubscribe) {
                this.removeSubscribe();
            }
        },
        methods: {

            setupData: function () {

                let self = this;
                self.callGetOrderHistoryApi(0)
                    .then(
                        self.getWhetherIsBooking
                    )
                    .then( () => {
                        //Promise內是非同步執行
                        //如果 then裡面是用函式形態包起來的話，函式內也會變成非同步執行
                        //若 then裡面是函式形態，但還要接 Promise的話，要以 return回傳 Promise物件，才會等待 Promise的回傳
                        //沒有 return的話， then不會等待 Promise的回覆，直接往下進行
                        if (self.isLogin) {
                            return self.callGetBookingRecordApi();
                        }
                    })
                    .then( () => {
                        //像這邊的用法 (外面有函式括號，但裡面沒有用 return)， then就不會等待 isJoinBrandMember回傳結果
                        //then 呼叫了 isJoinBrandMember以後，就直接往下繼續執行了
                        if (self.isLogin) {
                            return self.getRewardPointCount();
                        }
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

            },

            /** 呼叫 取得消費紀錄api */
            callGetOrderHistoryApi: function (storeId) {

                let self = this;
                self.isLoading = true;

                //取得消費紀錄
                return new Promise(function(resolve, reject) {

                    self.$http.fetchWithAuth`GetOrders${{
                        OffSet: 0,
                        pageSize: 3,
                        limitOrder: true,
                        filterStoreId: Number(self.filterStoreId),
                        isWeb: !self.isCordova,
                    }} ${json => {
                        if (json.data !== null && json.data !== '') {
                            self.historyList = json.data;
                            self.currentPage++ ;

                            resolve();
                        } else {
                            self.$public.showNotify(json.message, false);
                            reject('失敗');
                        }

                        // self.isSetUp = true;
                    }}`;
                });
            },

            /** 呼叫 取得紅利點數api */
            getRewardPointCount() {
                let self = this;
                this.$http.fetchWithAuthEncrypt`GetMyselfRewardPointCount${{
                    filterStoreId: self.filterStoreId,
                    findExpiration: true,
                }} ${json => {
                    if (self.$public.notNull(json.data)) {
                        if (self.$public.notNull(json.data.rewardPointData)) {
                            self.rewardPointList.tmz_load_push(...json.data.rewardPointData);
                        }
                    }
                }}`;
            },

            /** 呼叫 取得訂位紀錄api */
            callGetBookingRecordApi:function(){

                let dataList = [];
                let self = this
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetBookingRecord${{
                        id:Number(self.userData.id),
                        storeId:Number(self.filterStoreId),
                        lat: 0,
                        lng: 0,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            json.data.forEach(item => {

                                let storeImage = '';

                                if (self.$public.notNull(item.storeimage)) {
                                    storeImage = item.storeimage;
                                }


                                dataList.push({
                                    lat:item.lat,
                                    lng:item.lng,
                                    address:item.address,
                                    personCount:parseInt(item.adult)+parseInt(item.child)+parseInt(item.baby),
                                    bookingAt:item.booking_at,
                                    bookingDate:(item.booking_at).substr(0,10),
                                    bookingTime:(item.booking_at).substr(11,11).substr(0,5),
                                    brandName:item.brandname,
                                    bookingId:item.bookingid,
                                    city:item.city,
                                    storeId:item.storeid,
                                    storeName:item.name,
                                    storeTel:item.tel,
                                    township:item.township,
                                    adult:parseInt(item.adult),
                                    children:parseInt(item.child)+parseInt(item.baby),
                                    storeImage: storeImage,
                                });
                            });
                            self.bookList = dataList;
                        }

                        //完成
                        resolve();
                    }}`;
                });
            },

            /** 獲取使用者訂位資訊 */
            getWhetherIsBooking : function() {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetUserWhetherIsBooking${{
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.confirmBookingUrl = json.data.editbookingUrl+"/";
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            editBooking:function(item){
                let cryptoId = this.$crypto.encryptText(item.bookingId.toString())
                let secCryptoId = encodeURIComponent(cryptoId)
                let encryptString = "isWeb"+";"+encodeURIComponent(window.location.href);
                let encryptedString = this.$crypto.encryptText(encryptString);
                let secondEncrypt = encodeURIComponent(encryptedString);
                //訂位成功 booking-confirm, 訂位取消 booking-cancel
                let confirmPageUrlSet = this.confirmBookingUrl + item.storeId.toString() +"/booking-confirm?id="+secCryptoId+"&webToken="+secondEncrypt
                console.log(`confirmPageUrlSet : ${confirmPageUrlSet}`);
                //暫存目前點到的訂位資料
                //原本是以訂位網站傳來的 url來分析訂位資料，但從訂位記錄頁打開訂位網頁時就不用再從 url取資料，直接暫存點選的訂位記錄來取得加入行事曆的資料
                this.nowEditBookData = item;

                // this.$public.openUrlWithCloseBtn(confirmPageUrlSet);
                // 以 http方式添加 google行事曆事件 : https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20220118T110000.000ZZ/20220118T120000.000ZZ
                this.loadBookingPage(confirmPageUrlSet);
            },

            /** 取得星期幾 */
            getWeekName: function(setDate) {
                let day = new Date(setDate);
                let getWeek = day.getDay();
                return weekArr[getWeek];
            },

            /** 開啓訂位網頁 */
            loadBookingPage : function(urlSet) {

                let self = this;
                let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                // self.onBookingCompleted('https://booking-test.oinapp.com/app/39/booking-confirm?id=OKZRa5Hhec1J8j4kpptQLJpnWX4%3D&store=健康旗艦店&date=2021-11-28&time=18%3A00&result=success');
            },

            //關閉下滑彈窗
            closePullDownHistoryContent(){
                this.isShowPullDownHistoryContent = false;
            },

            //開啟消費紀錄詳細
            showHistoryContent(orderSn){
                this.pullDownHistoryOrderSn = orderSn;
                this.isShowPullDownHistoryContent = true;
            },

            //關閉下滑彈窗
            closePullDownHistory(){
                this.isShowPullDownHistory = false;
            },

            //開啟消費紀錄
            showHistory(){
                this.isShowPullDownHistory = true;
            },
            resetByLineWeb() {
                this.filterStoreId = this.$store.state.lineAtWebPageData.filterStoreId;
                if (this.filterStoreId > 0) {
                    this.setupData();
                }
            },
        },
    }
</script>
